module.exports = __webpack_public_path__ + "static/baranski-premium-d68b707345d8c894e97dd30583cb3c99.svg";